import React, { useEffect, useState } from "react";
import {
  IUser,
  IUserFilterModel,
  UserControlSlices,
} from "../../../slices/UserControlSlice";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux-store/store";
import {
  GetAllUser,
  Lock_UnlockAccount,
} from "../../../api/ssoapi/UserControlapi";
import lock from "../assets/lock.svg";
import unlock from "../assets/unlock.svg";
import PasswordGeneratorIcon from "../assets/Group 243.svg";
import { ETableRowActionFieldApplicable } from "../notificationPage/NotificationMangement";

interface ITableActionProps {
  row: IUser;
}

const TableAction: React.FC<ITableActionProps> = (props) => {
  const user = useSelector((state: RootState) => state.user.user);
  const { searchFilter } = useSelector((state: RootState) => state.userControl);
  const connection = useSelector(
    (state: RootState) => state.userControl.connection
  );
  const dispatch = useDispatch<AppDispatch>();

  const handleInvoke = () => {
    if (connection != null) {
      connection.on("check", (m) => console.log("Locked User", m));
      console.log(connection);
    }
  };

  useEffect(() => {
    handleInvoke();
  }, [connection]);

  // function for userAccount lock and Unlock
  const handleLockAndUnLock = async (data: IUser) => {
    try {
      const accountType =
        data.account.toString() === "LOCK" ? "UNLOCK" : "LOCK";
      if (user) {
        await dispatch(
          Lock_UnlockAccount({
            account: accountType,
            performedBy: user.email,
            userID: data.id,
          })
        ).then(() => {
          handleInvoke();
          if (searchFilter.globalSearch.value) {
            let lQuery: IUserFilterModel = {
              filters: searchFilter.globalSearchApiQuery.filters,
              isAscending: false,
              currentPageSize: searchFilter.apiQuery.currentPageSize,
              pageSize: searchFilter.apiQuery.pageSize,
              page: 1, //First time always get page 1
              isOr: true,
              isPageChanged: "",
              sortField: "",
            };

            dispatch(GetAllUser(lQuery));
          } else {
            dispatch(GetAllUser(searchFilter.apiQuery));
          }
        });
      }
    } catch (error) {}
  };

  // handle password generate popup and set the necessary data to for api action
  const handleTOGeneratePassword = (data: IUser): void => {
    dispatch(UserControlSlices.UpdateEnableGeneratePassword(true));
    dispatch(
      UserControlSlices.UpdateGeneratePassword({
        generatorEmail: data.email,
        generatorId: data.id,
      })
    );
  };

  // Action Button Validation
  const getActionBtnState = (): ETableRowActionFieldApplicable => {
    if (user?.email === props.row.email) {
      return ETableRowActionFieldApplicable.Blur;
    }
    return ETableRowActionFieldApplicable.Show;
  };

  // Action Button Tooltip Title
    // const getLockBtnTootipTitleState = (): string => {
    // if (user?.email === props.row.email) {
    //   return "Same Login User Can't Be Perform";
    // }
    // return props.row.account === "LOCK" ? "Locked" : "Active";
//   const getLockBtnTootipTitleState = (): string => {
//   debugger;
//   if (user?.email === props.row.email) {
//     return "Same Login User Can't Be Perform";
//   }
//   const ua = props.row.userAccount;
//   if (!ua) return "";

//   const status = ua.account ?? "";
//   if (status !== "LOCK") return "Active";

//   const actions = ua.adminAction ?? "";

//   if (actions.length === 0) return "Locked";

//   //  Sort by PerformedOn descending
//   const sorted = [...actions].sort((a, b) => {
//     const dateA = new Date(a.PerformedOn || a.performedOn).getTime();
//     const dateB = new Date(b.PerformedOn || b.performedOn).getTime();
//     return dateB - dateA; // DESC
//   });

//   // Latest action
//   const latest = sorted[0];
//   const performed = new Date(latest.PerformedOn || latest.performedOn);
//   const diffDays = Math.floor((Date.now() - performed.getTime()) / (1000 * 60 * 60 * 24));

//   if (diffDays > 30) return "Locked by Temporary Password";

//   return "Locked by Admin";
// };
const getLockBtnTootipTitleState = (): string => {
  debugger;
  // Same user cannot perform lock/unlock
  if (user?.email === props.row.email) {
    return "Same Login User Can't Be Perform";
  }
  const userAccount = props.row.userAccount;
  if (!userAccount) {
    return props.row.account === "LOCK" ? "Locked" : "Active";
  }

  const accountStatus = userAccount.Account || userAccount.account || "";

  // If account is LOCKED
  if (accountStatus === "LOCK") {
    const adminActions = userAccount.AdminAction || userAccount.adminAction || [];

    if (adminActions.length > 0) {
      const sorted = [...adminActions].sort((a, b) =>
        new Date(b.PerformedOn || b.performedOn).getTime() -
        new Date(a.PerformedOn || a.performedOn).getTime()
      );

      const last = sorted[0];
      const actionType = last.Action || last.action || "";

      if (actionType === "LOCK") {
        const performedBy = last.performedBy || "";
        if (performedBy === "LimitExist") {
          return "Locked by Incorrect Password";
        }
        return "Locked by Admin";
      }
    }
    return "Locked";
  }
  return "Active";
};


  const getPasswordBtnTootipTitleState = (): string => {
    if (user?.email === props.row.email) {
      // return "Same Login User Can't Be Perform";
      return "This action can't be done by same user";
    }
    return "Password Generator";
  };

  return (
    <>
      <div className="actions-container">
        <Tooltip title={getLockBtnTootipTitleState()}>
          <button
            disabled={
              getActionBtnState() === ETableRowActionFieldApplicable.Blur
                ? true
                : false
            }
            className={`action-icon-button ${
              getActionBtnState() === ETableRowActionFieldApplicable.Blur
                ? " button-opacity"
                : ""
            }`}
            id={`${props.row.id}`}
            onClick={() => handleLockAndUnLock(props.row)}
          >
            <img src={props.row.account === "LOCK" ? lock : unlock} alt="" />
          </button>
        </Tooltip>
        <button
          disabled={
            getActionBtnState() === ETableRowActionFieldApplicable.Blur
              ? true
              : false
          }
          className={`action-icon-button ${
            getActionBtnState() === ETableRowActionFieldApplicable.Blur
              ? " button-opacity"
              : ""
          }`}
          id={`${props.row.id}`}
          onClick={() => handleTOGeneratePassword(props.row)}
        >
          <Tooltip title={getPasswordBtnTootipTitleState()}>
            <img src={PasswordGeneratorIcon} alt="passwordGenerator" />
          </Tooltip>
        </button>
      </div>
    </>
  );
};

export default TableAction;
